<template>
    <v-container fluid class="share-manager">
        <!-- Read-only view: the viewer cannot edit sharing, so show the current state, not empty edit controls. -->
        <div v-if="readonly" class="share-manager-readonly">
            <div v-if="isSharedWithAll" class="text-body-1 d-flex align-center">
                <v-icon small class="mr-1">mdi-earth</v-icon>Shared with all teams
            </div>
            <div v-else-if="sharedTeamNames.length">
                <div class="text-caption grey--text mb-1">Shared with</div>
                <v-chip v-for="team in sharedTeamNames" :key="team.id" small class="mr-1 mb-1">{{ team.name }}</v-chip>
            </div>
            <div v-else class="text-body-2 grey--text">Not shared with any teams.</div>
        </div>
        <!-- Editable view -->
        <template v-else>
            <v-row>
                <v-col cols="12" md="3">
                    <v-checkbox v-model="isSharedWithAll" label="Share with All Teams"></v-checkbox>
                </v-col>
                <v-col cols="12" md="9">
                    <team-picker
                        v-model="currentTeams"
                        :teams="teams"
                        label="Shared with..."
                        multiple
                        chips
                        :disabled="isSharedWithAll"
                    ></team-picker>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div class="float-right">
                        <v-btn :loading="isSaving" :disabled="isSaving" color="secondary" @click="saveShares">Save</v-btn>
                    </div>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>
<script>
import api from '@/api'
export default {
    name: 'sharemanager',
    props: {
        shareAll: {
            type: Boolean,
            required: true,
        },
        shares: {
            type: Array,
            required: true,
        },
        isSaving: {
            type: Boolean,
            required: true,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            teams: [],
            currentTeams: [],
            removedTeams: [],
            addedTeams: [],
            isSharedWithAll: false,
        }
    },
    computed: {
        // The full team records for the teams this entity is currently shared with (for the read-only view).
        sharedTeamNames() {
            return this.teams.filter(team => this.currentTeams.includes(team.id))
        },
    },
    mounted() {
        this.getTeams()
        this.isSharedWithAll = this.shareAll
        this.currentTeams = this.shares
    },
    watch: {
        shareAll() {
            this.isSharedWithAll = this.shareAll
        },
        shares() {
            this.currentTeams = this.shares
        },
    },
    methods: {
        getTeams() {
            this.isLoading = true
            api.get('/team/getAllActive')
                .then(res => {
                    this.teams = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        saveShares() {
            this.$emit('save', this.isSharedWithAll, this.currentTeams)
        },
    },
}
</script>
